// import type from types.ts
import { Article } from '../../../types'; // don't remove this line

// import the thumbnail image
import thumbnailImage from './thumbnail.png'; // modify this import based on your image name

// import the new html file you wrote
const htmlContent = require('./article.html');

// edit the article object below with your article's info
const article: Article = {
  title: 'Combining Model-based Control and Reinforcement Learning',
  description: `Investigating how model-based control techniques can be integrated with reinforcement learning pipelines for improved performance, generalizability, and interpretability. We explore various hybrid architectures that leverage the strengths of both paradigms to tackle complex control tasks like locomotion and manipulation.`,
  thumbnail: thumbnailImage,
  html: htmlContent,
  id: 'combining-models-rl',
};

export default article;
